// removed by extract-text-webpack-plugin
module.exports = {"plan-wrapper":"plan-wrapper","icon-wrapper":"icon-wrapper","school-icon":"school-icon","plan-title":"plan-title","plan-price":"plan-price","plan-cycle":"plan-cycle","plan-detail":"plan-detail","additional-msg":"additional-msg","dollar":"dollar"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/planSubscriptionCard/planSubscriptionCard.scss
// module id = +93P
// module chunks = 0